import axios from '../axios'
// 个人中心
export const usercenter = data => {
    return axios({
        url: '/usercenter',
        method: 'get',
        params: data
    })
}
// 获取收藏信息
export const get_collection = data => {
    return axios({
        url: '/get_collection',
        method: 'get',
        params: data
    })
}

// 获取验证码
export const register_code = data => {
    return axios({
        url: '/register',
        method: 'get',
        params: data
    })
}
// 注册个人账号
export const register_zc = data => {
    return axios({
        url: '/register',
        method: 'POST',
        data: data
    })
}
// 修改密码
export const update_password = data => {
    return axios({
        url: '/update_password',
        method: 'POST',
        data: data
    })
}